export default function floatParser(value) {
    if (typeof value !== 'string') return value
    value = value.trim()
    if ([...value.matchAll(/[^\d,.]/g)].length !== 0) return NaN
    if ([...value.matchAll(/[.,]/g)].length > 1) return NaN
    value = value.replace(',', '.')
    return parseFloat(value)
}
